module.exports = __webpack_public_path__ + "assets/cascader.af4b06f5.svg";